import axios from "axios";
import EnvManager from '../../config/envManager';

const backend = axios.create({
  baseURL: `${EnvManager.BACKEND_URL}/api`,
  withCredentials: true
});

export const getSkills = async () => {
  try {
    const response = await backend.get('/skill');
    return response.data;
  }
  catch (error) {
    return null;
  }
};

export const postSkill = async () => {
  try {
    const response = await backend.post('/skill');
    return response.data;
  } catch (error) {
    return null;
  }
};
